import React, { ReactNode } from 'react';
import { Modal as BsModal, ModalProps as BsModalProps } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import { classCombine, isString } from 'tradevan-ui/consts';

export interface ModalProps extends BsModalProps {
  /** 控制modal出現或消失 */
  show: boolean;
  /** 單擊右上角X或非靜態背景時觸發modal關閉 */
  onHide: () => void;
  /** ModalHeader樣式: 只給string會產生ModalTitle樣式，給ReactNode可自訂樣式 */
  header?: ReactNode;
  /** ModalHeader className */
  headerClassName?: string;
  /** 右上角X關閉modal按鈕 預設為true */
  closeButton?: boolean;
  /** ModalBody樣式 */
  children?: ReactNode;
  /** ModalBody className */
  bodyClassName?: string;
  /** ModalFooter樣式 */
  footer?: ReactNode;
}

const Modal = (props: ModalProps) => {
  const {
    header,
    headerClassName,
    closeButton = true,
    children,
    bodyClassName,
    footer,
    ...other
  } = props;

  return (
    <BsModal {...other}>
      {header && (
        <ModalHeader
          closeButton={closeButton}
          className={classCombine('modal-header', headerClassName)}
        >
          {isString(header) ? <ModalTitle>{header}</ModalTitle> : header}
        </ModalHeader>
      )}
      <ModalBody className={bodyClassName}>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </BsModal>
  );
};
export default Modal;
